const userData = [
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'space-travel.png',
		folderName: 'space-travel',
		projectTitle: 'Space Travel',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'contact-card.png',
		folderName: 'contact-card',
		projectTitle: 'Contact Card',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29/airbnb-experiences',
		imgName: 'airbnb-clone.png',
		folderName: 'airbnb-clone',
		projectTitle: 'AirBnB Experiences',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'Travel-Journal.png',
		folderName: 'travel-journal',
		projectTitle: 'Travel Journal',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'tenzies.png',
		folderName: 'tenzies',
		projectTitle: 'Tenzies',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'react-info.png',
		folderName: 'react-info',
		projectTitle: 'React Info',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'starwars.png',
		folderName: 'starwars-api-react',
		projectTitle: 'Star Wars API',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'notes.png',
		folderName: 'notes',
		projectTitle: 'Notes',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'forms.png',
		folderName: 'forms',
		projectTitle: 'Forms',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'meme.png',
		folderName: 'memegenerator',
		projectTitle: 'Meme Generator',
	},
	{
		name: 'Lindsey',
		ghurl: 'https://github.com/CodeLikeAGirl29?tab=repositories',
		imgName: 'counter.png',
		folderName: 'counter',
		projectTitle: 'Counter',
	},
];

export { userData };
